import { useEffect } from "react"
import React from 'react'

const useScrollToElement = (id, dependency) => {
    useEffect(() => {
      // Attempt to scroll to the element after the DOM has likely updated
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({  block: 'start' });
        }
      }, 100); // You might need to adjust this timeout based on your application's behavior
    }, [dependency]);
  };

export default useScrollToElement